var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "documents-on-the-go-container" },
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c("p", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("e-sign-package.messages.nowSelectDocs")) +
                  "\n      "
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.currentTemplateData.files.length
        ? _c("v-client-table", {
            ref: "table",
            staticClass: "vue-custom-table no-pagination",
            attrs: {
              data: _vm.currentTemplateData.files,
              columns: _vm.table.columns,
              options: _vm.table.options,
              name: "documentsOnTheGo",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "name",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "h5",
                        {
                          staticClass:
                            "mb-0 font-sm text-light-gray bold d-inline",
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm._f("truncateFileName")(
                                  row.fileName,
                                  _vm.fileNameMaxLength
                                )
                              ) +
                              "\n      "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "actions",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "div",
                        { staticClass: "request-trash ml-4" },
                        [
                          _c("inline-prompt", {
                            staticStyle: { "font-size": "0.8rem" },
                            attrs: {
                              placement: "left",
                              "action-type": "delete",
                            },
                            on: {
                              accept: function ($event) {
                                return _vm.handleDeleteDocument(row.documentId)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              3814997880
            ),
          })
        : _c(
            "div",
            { staticClass: "d-flex flex-column align-items-center" },
            [
              _c(
                "no-results",
                {
                  attrs: {
                    "img-src": require("@Shared/@Assets/img/application-missing.png"),
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("e-sign-package.messages.emptyDocsOnTemplate")
                      ) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-2" },
        [
          _c(
            "b-col",
            {
              staticClass: "d-flex flex-row justify-content-end",
              attrs: { cols: "12" },
            },
            [
              _c(
                "simple-button",
                {
                  attrs: {
                    type: "primary btn-sm",
                    loading: _vm.uploadingDocument,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.fileInput.click()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("global.words.upload")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("input", {
                ref: "fileInput",
                staticStyle: { display: "none" },
                attrs: {
                  id: "file-upload",
                  type: "file",
                  accept:
                    "application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,image/png,image/tiff,image/jpeg",
                },
                on: { change: _vm.handleDocumentSelected },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "d-none", attrs: { for: "file-upload" } },
                [_vm._v(_vm._s(_vm.$t("documents.uploadDocument")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }